import { render } from "./VendorSelector.vue?vue&type=template&id=b6de93b8"
import script from "./VendorSelector.vue?vue&type=script&lang=js"
export * from "./VendorSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__